import { LayerDataCreate } from './data'
import { LayerViewCreate } from './view'

let LAYER_OBJECT = {}
export function createLayer(map, layer, readonly) {
  layer.metadata = Object.assign(
    {
      loading: false,
      bounds: null,
      fields: null,
    },
    layer.metadata
  )
  layer.selected = true
  if (layer.show == null) {
    layer.show = true
  }
  let temp = LayerDataCreate(layer.layer_type, layer)
  LAYER_OBJECT[temp.id] = temp

  layer.style = temp.getStyle()
  layer.data_id = temp.id

  let layer_view = LayerViewCreate(layer.layer_type, layer, readonly, temp)
  Object.defineProperty(layer_view, 'layer_ids', {
    get() {
      return temp.layer_ids
    },
  })
  Object.defineProperty(layer_view, 'style', {
    get() {
      return temp.getStyle()
    },
  })
  if (layer.group) {
    layer_view.group = layer.group
  }
  temp.addView(layer_view)
  if (temp.convertDefaultView) {
    temp.convertDefaultView(layer_view)
  }
  temp.addToMap(map)

  return layer_view
}
export function updateLayerSimple(map, layer) {
  let temp = LAYER_OBJECT[layer.data_id]
  if (!temp) return
  temp.toggleShow(map, layer.show)
  temp.setOpacity(map, layer.opacity)
}

export function toggleLayerShow(map, layer) {
  let temp = LAYER_OBJECT[layer.data_id]
  if (!temp) return
  temp.toggleShow(map, layer.show)
}
export function updateLayerStyle(map, layer) {
  let temp = LAYER_OBJECT[layer.data_id]
  if (!temp) return
  temp.setStyle(map, layer.style)
}

export function removeLayer(map, layer) {
  layer.selected = false
  let temp = LAYER_OBJECT[layer.data_id]
  LAYER_OBJECT[layer.data_id] = undefined
  if (!temp) return
  temp.removeFromMap(map)
}
export function getLayerData(layer) {
  return LAYER_OBJECT[layer.data_id]
}
export const LAYER_TYPE = {
  NBDS_VECTO_LAYER: 'nbds_vector_layer',
}
